import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import apiService from '@/helpers/apiService'
import { VIEW_ROUTE_PATH } from '@/constants/routes'
import {
  auth,
  loadSession,
  authNotRequired,
  checkDirectLogin,
  checkViewSession,
  createViewSession,
  loadAccountList,
  signInWithYandex,
  checkNotSignUp
} from './middleware'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      meta: {
        middleware: [authNotRequired, signInWithYandex]
      }
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () => import(/* webpackChunkName: "terms-of-service" */ '@/views/TermsOfUse.vue'),
      meta: {
        middleware: [authNotRequired]
      }
    },
    {
      path: '/pdp-policy',
      name: 'pdp-policy',
      component: () => import(/* webpackChunkName: "pdp-policy" */ '@/views/PrivacyPolicy.vue'),
      meta: {
        middleware: [authNotRequired]
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ '@/views/Logout.vue')
    },
    {
      path: '/view/init',
      name: 'view.init',
      meta: {
        middleware: [createViewSession] // creation of session for view profile only through this route
      }
    },
    {
      path: '/select-account',
      name: 'select-account',
      component: () => import(/* webpackChunkName: "selectAccount" */ '@/views/SelectAccount.vue'),
      meta: {
        middleware: [auth, loadAccountList]
      }
    },
    {
      path: '/',
      alias: VIEW_ROUTE_PATH,
      component: () => import(/* webpackChunkName: "profile" */ '@/layouts/Profile.vue'),
      meta: {
        middleware: [
          auth,
          loadSession,
          checkViewSession,
          checkDirectLogin
        ]
      },
      children: [
        // {
        //   path: 'summary',
        //   name: 'summary',
        //   component: () => import(/* webpackChunkName: "summary" */ '@/views/Summary.vue')
        // },
        {
          path: 'placements',
          name: 'placements',
          component: () => import(/* webpackChunkName: "placements" */ '@/views/Placements.vue')
        },
        {
          path: 'black-list',
          name: 'black-list',
          component: () => import(/* webpackChunkName: "black-list" */ '@/views/BlackList.vue')
        },
        {
          path: 'white-list',
          name: 'white-list',
          component: () => import(/* webpackChunkName: "white-list" */ '@/views/WhiteList.vue')
        },
        // {
        //   path: 'keywords',
        //   name: 'keywords',
        //   component: () => import(/* webpackChunkName: "keywords" */ '@/views/Keywords.vue')
        // },
        // {
        //   path: 'ads',
        //   name: 'ads',
        //   component: () => import(/* webpackChunkName: "promotions" */ '@/views/Ads.vue')
        // },
        {
          path: 'action-log',
          name: 'action-log',
          component: () => import(/* webpackChunkName: "action-log" */ '@/views/ActionLog.vue'),
          meta: {
            middleware: [checkNotSignUp]
          }
        },
        {
          path: 'action-log/placements/:id',
          name: 'action-log-placements',
          component: () => import(/* webpackChunkName: "action-log-placements" */ '@/views/ActionLogPlacements.vue')
        },
        {
          path: 'action-log/keywords/:id',
          name: 'action-log-keywords',
          component: () => import(/* webpackChunkName: "action-log-keywords" */ '@/views/ActionLogKeywords.vue')
        },
        {
          path: 'action-log/ads/:id',
          name: 'action-log-ads',
          component: () => import(/* webpackChunkName: "action-log-promotions" */ '@/views/ActionLogAds.vue')
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import(/* webpackChunkName: "settings" */ '@/views/Settings.vue')
        }
      ]
    },
    {
      path: '/404',
      name: '404',
      props: { type: '404' },
      component: () => import(/* webpackChunkName: "not-found" */ '@/views/Error.vue')
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      props: { type: '500' },
      component: () => import(/* webpackChunkName: "network-issue" */ '@/views/Error.vue')
    },
    {
      path: '*',
      redirect: { name: '404' }
    }
  ]
})

const middlewarePipeline = (context, middleware) => {
  const nextMiddleware = middleware[0]
  const restMiddleware = middleware.slice(1)

  if (!nextMiddleware) {
    return context.next
  }

  return (nextRoute) => {
    if (nextRoute !== undefined) {
      context.next(nextRoute)
    } else {
      const nextPipeline = middlewarePipeline(context, restMiddleware)
      nextMiddleware({ ...context, next: nextPipeline })
    }
  }
}

// Разрешение переходов
router.beforeEach((to, from, next) => {
  apiService.cancelRequests()

  // middleware pipeline
  const middleware = to.matched.reduce((guards, matchedRoute) => {
    const routeGuards = matchedRoute.meta.middleware
      ? matchedRoute.meta.middleware.filter(someGuard => !guards.includes(someGuard))
      : []

    if (routeGuards && routeGuards.length) {
      return [...guards, ...routeGuards]
    }

    return guards
  }, [])

  const firstMiddleware = middleware[0]
  if (!firstMiddleware) {
    next()
    return
  }
  const restMiddleware = middleware.slice(1)

  const context = {
    to,
    from,
    next,
    store
  }

  const nextPipeline = middlewarePipeline(context, restMiddleware)
  firstMiddleware({ ...context, next: nextPipeline })
})

export default router
